import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Card, Column, Row } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { AddTimeActivityButton } from './AddTimeActivity/AddTimeActivity';
import styles from './TimeActivityCard.module.scss';
import { TimeActivityDetails } from './TimeActivityDetails/TimeActivityDetails';
import { TimeActivityExternalLink } from './TimeActivityExternalLink/TimeActivityExternalLink';
export const GetTimeActivityCardTID = (parentTestId)=>getTestIds(parentTestId);
export const TimeActivityCard = (param)=>{
    let { timeActivity, accountingName, onAdd, bi, testId } = param;
    const { TimeActivityCardTestIds } = useMemo(()=>GetTimeActivityCardTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(Card, {
        bi: bi.card,
        testId: TimeActivityCardTestIds.Root(),
        className: styles.card,
        children: /*#__PURE__*/ _jsxs(Row, {
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ _jsx(TimeActivityDetails, {
                    timeActivity: timeActivity,
                    testId: TimeActivityCardTestIds.Details()
                }),
                /*#__PURE__*/ _jsxs(Column, {
                    alignItems: "end",
                    gap: 12,
                    children: [
                        /*#__PURE__*/ _jsx(TimeActivityExternalLink, {
                            href: timeActivity.url,
                            accountingName: accountingName,
                            bi: bi.externalLink,
                            testId: TimeActivityCardTestIds.ExternalLink()
                        }),
                        /*#__PURE__*/ _jsx(AddTimeActivityButton, {
                            onAdd: onAdd,
                            bi: bi.add,
                            testId: TimeActivityCardTestIds.Add()
                        })
                    ]
                })
            ]
        })
    });
};
